import axios from "axios";

export function getMyVote(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/getMyVote'
    });
}
export function postMyVote(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/postMyVote'
    });
}
export function deleteJudge(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/deleteJudge'
    });
}
export function postVoteChant(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/postVoteChant'
    });
}
export function postVoteCarol(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/postVoteCarol'
    });
}
export function postVoteStarNight(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/postVoteStarNight'
    });
}
export function deleteGroupChantVotes(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/deleteGroupChantVotes'
    });
}
export function deleteGroupCarolVotes(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/deleteGroupCarolVotes'
    });
}